import React, { useCallback, useRef, useState, useEffect } from "react";
import QuickButton from "./QuickButton/QuickButton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLoginNavigationData } from "../../../store/loginNavigation/LoginNavigation.slice";
import { setLoginNew } from "../../../store/LoginNew/loginNew.slice";
import { openSlotCasinoPopUp } from "../../../store/slotCasinoPopUp/slotCasinoPopUp.slice";
import { USER_DATA } from "../../../config/app.config";
import { toastr } from "react-redux-toastr";

const QuickButtons = ({ quickButtons }) => {
  const slider = useRef(null);
  const [isDown, setIsDown] = useState(false);
  const [isSlide, setIsSlide] = useState(false);
  const [startX, setStartX] = useState("");
  const [scrollLeft, setScrollLeft] = useState("");
  const [buttonsData, setButtonsData] = useState(quickButtons); // State to store buttons
  const user = useSelector((state) => state.user);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let userDetail = localStorage.getItem(USER_DATA);
  let userData = JSON.parse(userDetail);

  useEffect(() => {
    const interval = setInterval(() => {
      handleAutoScroll();
    }, 5000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, []);

  const handleAutoScroll = () => {
    if (slider.current) {
      const { scrollLeft } = slider.current;
      const scrollValue =
        window?.innerWidth >= 768 ? 290 : window?.innerWidth >= 640 ? 250 : 175;
      slider.current.scrollTo({
        left: scrollLeft + scrollValue,
        behavior: "smooth",
      });
    }
  };

  const appendData = useCallback(() => {
    // Append the data to create the infinite scroll effect
    setButtonsData((prevData) => [...prevData, ...quickButtons]);
  }, [quickButtons]);

  const handleScroll = useCallback(() => {
    if (slider.current) {
      const { scrollLeft, scrollWidth, clientWidth } = slider.current;

      if (scrollLeft + clientWidth >= scrollWidth - 50) {
        appendData();
      }
    }
  }, [appendData]);

  const throttleScroll = useCallback(() => {
    if (slider.current) {
      requestAnimationFrame(handleScroll);
    }
  }, [handleScroll]);

  const quickButtonsList = buttonsData.map((itemButton, index) => {
    const handleClickEvent = async (item) => {
      if (userData?.is_demo) {
        toastr.error("", "Please login from your read ID.");
        return;
      }

      if (auth) {
        if (item?.name == "Sportsbook") {
        } else {
          navigate(`/${item?.link}`);
        }
      } else {
        dispatch(setLoginNew(true));
        dispatch(setLoginNavigationData({ page: item?.link, ids: [] }));
      }
    };

    return (
      <div
        title={itemButton?.name}
        key={`${itemButton?.name}-${index}`}
        className="grid grid-row-2"
      >
        <QuickButton
          name={itemButton.row_1.name}
          img={itemButton.row_1.img}
          backgroundImage={itemButton.row_1.backgroundImage}
          onSelect={() => {
            handleClickEvent(itemButton.row_1);
          }}
        ></QuickButton>
        <QuickButton
          name={itemButton.row_2.name}
          img={itemButton.row_2.img}
          backgroundImage={itemButton.row_2.backgroundImage}
          onSelect={() => {
            handleClickEvent(itemButton.row_2);
          }}
        ></QuickButton>
      </div>
    );
  });

  let quickButtonsStyle;
  if (quickButtons.length == 1) {
    quickButtonsStyle = { gridTemplateColumns: "1fr" };
  }
  return (
    <div className="py-1 px-[2px] w-full" style={quickButtonsStyle}>
      <div className="flex flex-col items-center justify-start w-full scrollSmooth no-scrollbar">
        <div
          className="flex overflow-auto w-full scrollSmooth no-scrollbar"
          ref={slider}
          onMouseDown={(e) => {
            setIsDown(true);
            setStartX(e.pageX - slider.current.offsetLeft);
            setScrollLeft(slider.current.scrollLeft);
          }}
          onMouseUp={() => {
            if (isSlide) {
              setTimeout(() => setIsSlide(false), 500);
            }
            setIsDown(false);
          }}
          onMouseMove={(e) => {
            if (!isDown) return;
            e.preventDefault();
            setIsSlide(true);
            const x = e.pageX - slider.current.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            slider.current.scrollLeft = scrollLeft - walk;
          }}
          onMouseLeave={() => {
            setIsDown(false);
            setIsSlide(false);
          }}
          onScroll={throttleScroll}
        >
          {quickButtonsList}
        </div>
      </div>
    </div>
  );
};

export default QuickButtons;
